import { Component, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import { ModalService } from 'src/app/core/services';
import { Steps } from 'src/app/core/models';

@Component({
  selector: 'app-message-vehicle-white-list-modal',
  templateUrl: './message-vehicle-white-list-modal.component.html',
  styleUrls: ['./message-vehicle-white-list-modal.component.sass']
})
export class MessageVehicleWhiteListModalComponent extends BaseModal implements OnInit {
  public vehicleWhiteList;
  isValid = true;
  public stepI18n = [];
  public steps = Object.keys(Steps);

  constructor(
    public modalService: ModalService
  ) {
    super(modalService);
   }

  ngOnInit() {
    this.vehicleWhiteList = this.initialState;
  }

  get lastState(): any {
    return null;
  }

  async onAllSubmited(): Promise<any> { }

  getStep(step) {
    if (this.stepI18n.length === 0 || step == null) {
      return;
    }
    return  this.stepI18n.find(p => p.id === step).value;
  }
}
